import { ApiService } from '~/shared/api'
import type { FilterBlockDto } from '~/shared/filters/employer-vacancies'
import type { GetAccountVacanciesFiltersParams } from '~/interfaces/AccountVacancies'

export default class AccountVacanciesFiltersService extends ApiService {
  protected route: string = 'users-management/vacancies/filters'

  async getAccountVacanciesFilters({ baseUrl, token }: GetAccountVacanciesFiltersParams) {
    const { data } = await this.requestService.request<{ data?: FilterBlockDto[] }>({
      url: '/api/v1/yavagro/users-management/vacancies/filters',
      baseURL: baseUrl,
      params: { token }
    })
    return data?.data ?? []
  }
}
